import React from 'react';

import {
  InboxNotificationDetailTimelineEvent,
  NotificationEventType,
} from 'src/entities/Notifications';
import { DateUtils } from 'src/utils';

import { AlertCircleIcon, SuccessCheckmarkIcon } from '../Icons';
import { NotificationClipboardIcon } from '../Icons/ModuleIcons/NotificationClipboardIcon';
import { SendNotificationIcon } from '../Icons/SendNotificationIcon';
import { Timeline } from '../UI/Timeline';

export const NotificationTimeline: React.FC<{
  events: InboxNotificationDetailTimelineEvent[];
}> = ({ events }) => {
  const renderIcon = (eventType: NotificationEventType) => {
    switch (eventType) {
      case 'forms.created':
      case 'form.created':
        return <NotificationClipboardIcon fill="#0E0E10" />;
      case 'forms.requested':
      case 'formResponse.requested':
      case 'invoice.requested':
      case 'esign.requested':
      case 'contract.requested':
      case 'autoChargePayment.requested':
      case 'invoice.processing':
        return <SendNotificationIcon fill="#0E0E10" />;
      case 'forms.completed':
      case 'formResponse.completed':
      case 'invoice.paid':
      case 'esign.completed':
      case 'contract.signed':
      case 'files.new':
      case 'files.created':
      case 'customApp.action':
        return (
          <SuccessCheckmarkIcon
            className="text-medium-dark-green"
            style={{
              fontSize: '20px',
            }}
          />
        );
      case 'invoice.paymentFailed':
      default:
        return <AlertCircleIcon className="h-5 w-5" />;
    }
  };
  return (
    <div className="p-5">
      <Timeline
        items={events.map((event) => ({
          // eventId should be unique for each event
          id: event.eventId,
          icon: renderIcon(event.eventType),
          title: event.label,
          // format date mm/dd/yyyy at hh:mm
          subTitle: `${DateUtils.formatDate(
            event.date,
            `MMM D, YYYY [at] hh:mm`,
          )}`,
        }))}
      />
    </div>
  );
};
